import React from "react";

function ChevronUpSvg(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "20"}
      height={props.height || "20"}
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke={props.fill || "#667085"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4.167 12.5L10 6.667 15.833 12.5"
      ></path>
    </svg>
  );
}

export default ChevronUpSvg;
